module.exports = __webpack_public_path__ + "assets/3de5e48d28acdf59a18f1de84bc0132c.mp3";